import styled from 'styled-components';

import { MinBreakpointV2 } from '@xemplo/style-constants';

export {
  CardContainer,
  Header,
  IconWrapper,
  Title,
  Field,
  Label,
  Value,
} from '../shared/card-styles';

export const FieldsGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media ${MinBreakpointV2.medium} {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
`;
